const comments = [
  { id: 1, name: '追剧达人阿杰', text: '用了半年了，真的秒开！以前在其他平台等缓冲等到崩溃，爱丫爱丫影院完全不用等，画质还特别清晰，已经安利给全家人了。', rating: 5 },
  { id: 2, name: '电影控小美', text: '最让我惊喜的是完全没广告！看剧体验太纯粹了，一口气追完一整季美剧，中间没有任何打断，这才叫真正的观影。', rating: 5 },
  { id: 3, name: '深夜刷剧党', text: '片源更新速度很快，热门电影上线第二天就能看。高清画质在线播放不卡顿，连我家百兆宽带都跑得很流畅。', rating: 5 },
  { id: 4, name: '影评人老王', text: '作为一个看了 20 年电影的老影迷，爱丫爱丫影院的片库真的很全，很多冷门老片都能找到，而且播放质量稳定，强烈推荐。', rating: 4 },
  { id: 5, name: '学生观影族', text: '免费又高清，对于我们学生党太友好了！不用充会员也能看最新的电影和电视剧，宿舍四个人一起用也完全不卡。', rating: 5 },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-900 text-center mb-2">用户口碑</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">来自真实观影用户的使用反馈</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((c) => (
            <div key={c.id} className="bg-background-50 rounded-lg p-5 border border-background-200/70">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className={`ri-star-fill text-xs ${i < c.rating ? 'text-accent-500' : 'text-background-300'}`}></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">&ldquo;{c.text}&rdquo;</p>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 text-xs font-medium">{c.name.charAt(0)}</span>
                <span className="text-xs font-medium text-foreground-800">{c.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}